import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';

// No route preloading: this app's primary traffic is QR scans hitting the
// public product page. PreloadAllModules would eagerly pull the entire admin
// bundle (~480 kB) + firebase/auth onto every consumer device in the
// background — wasted mobile data for code they never use. Lazy routes
// (admin, auth) load on navigation instead.
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
  ]
};
